import styled from 'styled-components';
import { Colors, Switch } from '@inplayer-org/inplayer-ui';
import React from 'react';
import { Event } from 'ducks/merchantDucks/externalAccount/types';
import { transparentize } from 'polished';

// hooks
import useRestrictionRules from 'restrictions/roles/hooks/useRestrictionRules';

// rules
import Rules from 'restrictions/roles/constants/rules';

// styled components
import { BlueTypography } from 'components/SharedStyledElements';

const VideoContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 1rem;
  align-items: flex-start;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  cursor: auto;
  overflow: visible;
  background: ${Colors.white};
  border-radius: 5px;
  box-shadow: 0 0 4px 1px ${transparentize(0.87, Colors.fontDarkGray)};
`;
const SwitchContainer = styled.div`
  width: 100%;
  border-top: 1px solid ${Colors.gray};
  padding-top: 1rem;
`;
const MiddleContainer = styled.div`
  width: 100%;
`;
const HeaderContainer = styled.div`
  width: 100%;
  height: 2rem;
  display: flex;
  justify-content: space-between;
`;
const WrappedSpan = styled.span`
  line-height: 1.5;
  word-break: break-all;
  margin-left: 0.2rem;
`;

interface Props {
  event: Event;
  handleCurrentEvent: (id: number, name: string) => void;
  currentEvent: number | null;
}

const EventbriteEvent: React.FC<Props> = ({ event, handleCurrentEvent, currentEvent }) => {
  const { hasRule } = useRestrictionRules();
  const isReadOnly = hasRule(Rules.READONLY_ASSETS_AND_PACKAGES);
  const {
    name: { text },
    id,
    url,
  } = event;
  return (
    <VideoContainer key={id}>
      <HeaderContainer>
        <BlueTypography variant="h6">{text}</BlueTypography>
      </HeaderContainer>
      <MiddleContainer>
        <div>
          <span>
            <b>Event Id:</b>
          </span>
          <WrappedSpan>{id}</WrappedSpan>
        </div>
        <div>
          <span>
            <a href={url} target="_blank" rel="noopener noreferrer">
              Visit event &rarr;
            </a>
          </span>
        </div>
      </MiddleContainer>
      <SwitchContainer>
        <Switch
          id={`event-id-${id}`}
          label={currentEvent === id ? 'Event related' : 'Relate event'}
          checked={currentEvent === id}
          onChange={() => handleCurrentEvent(id, text)}
          disabled={isReadOnly}
        />
      </SwitchContainer>
    </VideoContainer>
  );
};

export default EventbriteEvent;
